import {Fragment} from 'react';
import * as css from './Legend.css';

function Legend({items}: {items: {color: string; text: string}[]}) {
    return (
        <css.legend>
            {items.map((item, i) => (
                <Fragment key={item.text}>
                    {i > 0 && <css.vLine />}
                    <css.legendItem><css.dot $c={item.color} />{item.text}</css.legendItem>
                </Fragment>
            ))}
        </css.legend>
    );
}
export default Legend;
